<template>
  <div class="recorder">
    Test Command
    <input
      v-model="command"
      placeholder="enter test command"
      v-on:keyup.enter="processCommand"
    />
    <button @click="processCommand">GO!</button>

    <h1>{{ msg }}</h1>

    <div>
      <button @click="startMetronome()">{{playPause}}</button>
    </div>

    <div>Bass Drum Volume: {{bassDrumAmp}}</div>
    <div>Snare Drum Volume: {{snareDrumAmp}}</div>

    <div>

      <filter-ball :center="90" color="#FF0000" filter="lowpass" @volume="bassDrumEvent" />

      <filter-ball :center="160" color="#00FF00" filter="bandpass" />

      <filter-ball :center="6000" color="#0000FF" filter="highpass" @volume="snareDrumEvent"/>

    </div>

    <div>
      <audio id="song" src="/static/sounds/Clap Clap - Flowing Like a Snake in Ophiuchus Arms.mp3" controls />
    </div>
  </div>
</template>

<script>
// import pizzicato from 'pizzicato';
import Tone from 'tone';
// import RealTimeBPMAnalyzer from '@/js/bpm/index';
import FilterBall from '@/components/FilterBall';

const COMMANDS = {
  recordDrums: 'RECORD DRUMS',
  recordBass: 'RECORD BASS',
  recordMelody: 'RECORD MELODY',
  recordAudio: 'RECORD AUDIO',
};

export default {
  name: 'recorder',
  components: {
    FilterBall,
  },
  data() {
    return {
      msg: 'Welcome to VOS Recorder... do we have an audio context?',
      playing: false,
      command: '',
      bassDrumAmp: 0,
      snareDrumAmp: 0,
      snareDrum: new Tone.Player(
        '/static/sounds/drums/808/SD0010.WAV',
      ).toMaster(),
      metronomeStarted: false,
      metronomePart: new Tone.Part(((time, note) => {
        // the notes given as the second element in the array
        // will be passed in as the second argument
        console.log('trigger?');
        this.synth.triggerAttackRelease(note, '8n', time);
      }), [[0, 'C2'], ['0:2', 'C3'], ['0:3:2', 'G2']]),
      playPause: 'Play with metronome',
      synth: new Tone.Synth().toMaster(),
      snareSynth: new Tone.Synth().toMaster(),
      snarePart: new Tone.Part(((time, note) => {
        // this.snareSynth.triggerAttackRelease(note, '32n', time);
        this.snareDrum.start(time);
      }), []),
      eventAdding: false,
    };
  },
  methods: {

    // addNote(inNote) {

    // },

    bassDrumEvent(inVolume) {
      if (inVolume > 0.1) {
        this.bassDrumAmp = inVolume;
      }
    },

    snareDrumEvent(inVolume) {
      if (inVolume > 0.1 && !this.eventAdding) {
        this.eventAdding = true;
        this.snareDrumAmp = inVolume;


        console.log(Tone.Transport.position);
        const barsBeats = Tone.Transport.position.split(':');
        const clockPosition = `0:${barsBeats[1]}:${Math.floor(barsBeats[2]) - 1}`;
        this.snarePart.add(clockPosition, 'C5');
        console.log(`rendering at ${clockPosition}`);

        setTimeout(() => {
          this.eventAdding = false;
        }, 200);
      }
    },

    processCommand() {
      console.log('processing test command!');
      console.log(this.command);

      if (this.command.toUpperCase().startsWith(COMMANDS.recordDrums)) {
        this.msg = 'record drums command';


        // const scriptProcessorNode = window.audioContext.createScriptProcessor(4096, 1, 1);
        // // Connect everything together
        // scriptProcessorNode.connect(window.audioContext.destination);
        // window.userMediaStreamSource.connect(scriptProcessorNode);
        // window.userMediaStreamSource.connect(window.audioContext.destination);
        // const onAudioProcess = new RealTimeBPMAnalyzer({
        //   scriptNode: {
        //     bufferSize: 4096,
        //     continuousAnalysis: true,
        //     computeBPMDelay: 1000,
        //     stabilizationTime: 1000,
        //     numberOfInputChannels: 1,
        //     numberOfOutputChannels: 1,
        //   },
        //   pushTime: 1000,
        //   pushCallback: (err, bpm) => {
        //     console.log('push callback');

        //     if (err) {
        //       console.log(err);
        //     } else if (bpm) {
        //       this.msg = `detect BPM: ${bpm[0].tempo}`;
        //       console.log(bpm);
        //     }
        //   },
        // });
        // // Attach realTime function to audioprocess event.inputBuffer (AudioBuffer)
        // scriptProcessorNode.onaudioprocess = (e) => {
        //   onAudioProcess.analyze(e);
        // };
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordBass)) {
        this.msg = 'record bass command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordMelody)) {
        this.msg = 'record melody command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordAudio)) {
        this.msg = 'record AUDIO command';
      } else {
        this.msg = 'unknown command: try record audio, record drums, etc';
      }
      this.command = '';
    },
    startMetronome() {
      if (this.metronomeStarted) {
        console.log('stopping metronome');
        this.metronomePart.stop();
        this.snarePart.stop();
        this.playPause = 'PLAY with metronome';
        this.metronomeStarted = false;
        this.transport.stop();
      } else {
        console.log('starting metronome');
        this.metronomeStarted = true;
        this.playPause = 'PAUSE with metronome';

        this.metronomePart.loop = true;
        this.metronomePart.start(0);
        this.snarePart.loop = true;
        this.snarePart.start(0);
        this.transport.start();
      }


      // const loop = new Tone.Loop((time) => {
      //   synth.triggerAttackRelease('a#2', '8n', time);
      // }, '1n');

      // const loop2 = new Tone.Loop((time) => {
      //   synth2.triggerAttackRelease('c#4', '2n', time);
      // }, '2n');

      // const snareDrum = new Tone.Player(
      //   '/static/sounds/drums/808/SD0010.WAV',
      // ).toMaster();

      // const loop3 = new Tone.Loop((time) => {
      //   snareDrum.start(time);
      // }, '2n');

      // loop.start();
      // loop2.start();

      // loop3.humanize = true;
      // loop3.start();

      // if (this.playing) {
      //   this.playing = false;
      //   Tone.Transport.stop();
      // } else {
      //   this.playing = true;
      //   Tone.Transport.start();
      // }

      // analyze(snareDrum.buffer)
      //   .then((tempo) => {
      //     console.log('analyze from snare is back');
      //     console.log(tempo);
      //   })
      //   .catch((err) => {
      //     console.log('analyze blew up, sad panda.');
      //     console.error(err);
      //   });

      // const freqs = [
      //   3729.31,
      //   3322.438,
      //   2959.955,
      //   2489.016,
      //   2217.461,
      //   1864.655,
      //   1661.219,
      //   1479.978,
      //   1244.508,
      //   1108.731,
      //   932.3275,
      //   932.3275,
      //   739.9888,
      //   622.254,
      //   554.3653,
      //   466.1638,
      //   415.3047,
      //   369.9944,
      //   311.127,
      //   277.1826,
      //   233.0819,
      //   207.6523,
      //   184.9972,
      //   155.5635,
      //   138.5913,
      //   116.5409,
      //   103.8262,
      //   92.49861,
      //   77.78175,
      // ];
      // const val = freqs[Math.floor(Math.random() * freqs.length)];
      // const sawtoothWave = new pizzicato.Sound({
      //   source: 'wave',
      //   options: {
      //     type: 'sawtooth',
      //     frequency: val,
      //   },
      // });
      // const delay = new pizzicato.Effects.Delay({
      //   feedback: 0.8,
      //   time: 0.22,
      //   mix: 0.75,
      // });
      // sawtoothWave.addEffect(delay);
      // sawtoothWave.play();
      // setTimeout(() => {
      //   sawtoothWave.stop();
      // }, 500);
    },
  },
  mounted() {
    console.log('ok, recorder is mounted');

    this.transport = Tone.Transport;


    // const sawtoothWave = new pizzicato.Sound({
    //   source: 'wave',
    //   options: {
    //     type: 'sawtooth',
    //     frequency: 92.49861,
    //   },
    // });

    // const delay = new pizzicato.Effects.Delay({
    //   feedback: 0.8,
    //   time: 0.22,
    //   mix: 0.75,
    // });
    // sawtoothWave.addEffect(delay);

    // sawtoothWave.play(2, 4);
    // setTimeout(() => {
    //   sawtoothWave.stop();
    // }, 3000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}
</style>



// WEBPACK FOOTER //
// src/components/Recorder.vue